/**
 * Read-only subset of FPM's plug commission API client.
 *
 * GolfTrack only needs the queries that feed the read-only Power/Charger
 * dashboards (device list, per-plug live power, building list). All
 * write/commissioning endpoints are intentionally omitted here; if you need
 * them, hit FPM directly from FPM's own UI.
 */

import axios from 'axios';
import { fpmEndpointLink } from '../../../index';

export interface ChargerInfoDevice {
  NodeID: string;
  BuildingID: string;
  PlugNum: number;
  ChargeStart?: string | null;
  ChargeEnd?: string | null;
  Status?: string | null;
  Enabled?: number;
  Available?: number;
  OnOff?: number | null;
  PairingCode?: string | null;
  LastRx?: string | null;
  WifiName?: string | null;
  CreatedAt?: string | null;
  /** True if device responded recently (within ~90s) */
  reachable?: boolean;
  /** 'Reachable' | 'Likely Unplugged' */
  status?: string;
}

export interface MatterPowerMeasurements {
  activePower?: number;
  voltage?: number;
  current?: number;
}

export async function listBuildingIds(): Promise<string[]> {
  const { data } = await axios.get<string[]>(`${fpmEndpointLink}plugs/building-ids`);
  return Array.isArray(data) ? data : [];
}

export async function listDevices(buildingID?: string): Promise<ChargerInfoDevice[]> {
  const params = buildingID && buildingID !== 'all' ? { BuildingID: buildingID } : { BuildingID: 'all' };
  const { data } = await axios.get<{ devices: ChargerInfoDevice[] }>(
    `${fpmEndpointLink}plugs/devices`,
    { params }
  );
  return data.devices || [];
}

export async function getDevicePower(nodeId: string): Promise<MatterPowerMeasurements> {
  const { data } = await axios.get<MatterPowerMeasurements>(
    `${fpmEndpointLink}plugs/devices/${nodeId}/power`
  );
  return data;
}
